<div class="knowledge-hub-container" id="knowledge-hub-container">
  <nav
    mat-tab-nav-bar
    [tabPanel]="tabPanel"
    class="knowledge-hub-tabs"
    [mat-stretch-tabs]="false"
    [attr.aria-label]="translate('nav.knowledgeHub')"
    id="knowledge-hub-tabs">
    <a
      mat-tab-link
      *ngFor="let tab of visibleTabs"
      [routerLink]="[tab.path]"
      routerLinkActive
      #rla="routerLinkActive"
      [active]="rla.isActive"
      [attr.aria-current]="rla.isActive ? 'page' : null"
      [id]="'knowledge-hub-tab-' + tab.path">
      <mat-icon aria-hidden="true">{{ tab.icon }}</mat-icon>
      <span class="knowledge-hub-tab-label">{{ translate(tab.labelKey) }}</span>
    </a>
  </nav>

  <mat-tab-nav-panel #tabPanel class="knowledge-hub-panel" id="knowledge-hub-panel">
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>
